import React from 'react';
import BasePage from '../BasePage';
import { Button, Card, Divider, Group, Image, Stack, Switch, Text } from '@mantine/core';
import { IconSettings } from '@tabler/icons-react';
import Office365Brand from "../../assets/img/office-365-brand.png"
import EntraBrand from "../../assets/img/entra-brand.png"
import ZohoBrand from "../../assets/img/zoho-brand.png"

function IntegrationCard({ title, brand, description }) {
    return (
        <Card w={350} p={0}>
            <Stack gap={0} px={32} py={16}>
                <Image src={brand} w="3rem" mb="md" />
                <Text fw={600} fz="1.15rem">{title}</Text>
                <Text c="var(--text-dimmed)" fz="0.8rem">{description}</Text>
            </Stack>

            <Divider />

            <Group px={16} py={8} justify="space-between">
                <Button className="unify-btn-subtle" leftSection={<IconSettings size="1.125rem" />}>Manage</Button>
                <Switch color="var(--primary-color)" mr="sm" />
            </Group>
        </Card>
    )
}

function IntegrationsPage() {
    return (
        <BasePage
            breadcrumbs={[{ label: "Integrations" }]}
        >
            <Group grow>
                <IntegrationCard title="Office 365" brand={Office365Brand} description="Connect your Office 365 account to send emails directly from the platform." />
                <IntegrationCard title="Entra ID" brand={EntraBrand} description="Connect your Entra account to enable secure authentication and user access." />
                <IntegrationCard title="Zoho Desk" brand={ZohoBrand} description="Connect your Zoho Desk account to manage and respond to support tickets." />
            </Group>
        </BasePage>
    )
};

export default IntegrationsPage;